import React, { useState, useEffect } from 'react';
import { List, Datagrid, TextField, TextInput, Filter, Show, SimpleShowLayout, ShowButton } from 'react-admin';
import { Create, SimpleForm, usePermissions } from 'react-admin';
import { cloneElement } from 'react';
import {
    useListContext,
    TopToolbar,
    CreateButton,
    ExportButton,
    EditButton,
    Edit,
    SaveButton,
    Toolbar,
    sanitizeListRestProps,
} from 'react-admin';
import PermitsList from '../permits/permitsList';
import DeleteRoleButtonWithConfirmation from '../buttons/deleteRoleButtonWithConfirmation'


const styles = {
    div1: {
        display: 'block',
        width: "25%",
        float: "left",
        position: "flex",
        marginRight: "10px"
    },
    div1Mobile: {
        display: 'block',
        width: "50%",
        float: "left",
        position: "flex",
        marginLeft: "2%",
        marginRight: "2%"
    },
    div2: {
        display: 'block',
        width: "74%",
        float: "left",
        position: "flex"
    },
    div2Mobile: {
        display: 'block',
        width: "100%",
        float: "left",
        marginLeft: "2%",
        marginRight: "2%",
        marginTop: "2%",
        position: "flex"
    },
    table: {
        overflowX: "auto"
    }
};

const ListActions = (props) => {
    const {
        className,
        exporter,
        filters,
        maxResults,
        ...rest
    } = props;
    const {
        currentSort,
        resource,
        displayedFilters,
        filterValues,
        basePath,
        showFilter,
        total,
    } = useListContext();
    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }
    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
            {permissions.includes("roles.create") &&
                <CreateButton basePath={basePath} label="Crear" />
            }
            {permissions.includes("roles.export") &&
                <ExportButton
                    label="Exportar csv"
                    disabled={total === 0}
                    resource={resource}
                    sort={currentSort}
                    filterValues={filterValues}
                    maxResults={maxResults}
                />
            }
            {/* Add your custom actions */}
        </TopToolbar>
    );
};

const RoleTitle = ({ record, optionTitle }) => {
    if (optionTitle) {
        return ""
    }
    return <span>Rol - {record ? `${record.role}` : ''}</span>;
};

export const RolesList = props => (
    <List filters={<RoleFilter />} {...props} actions={<ListActions />} >
        <Datagrid>
            <ShowButton label="Ver" />
            <TextField source="role" label="Nombre del rol" />
            <TextField source="description" label='Descripción' />
        </Datagrid>
    </List>
);

const RoleShowActions = ({ basePath, data, resource, edit = false, f = false }) => {
    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }
    if (edit && permissions.includes("roles.edit") && data && data.hasOwnProperty("blocked") && !data.blocked) {
        return (
            <TopToolbar>
                {(edit) ? <EditButton basePath={basePath} record={data} label="Editar rol" /> : null}
                {permissions.includes("roles.delete") && <DeleteRoleButtonWithConfirmation basePath={basePath} record={data} resource={resource} undoable={false} label={data.removed ? "Eliminado" : "Eliminar"} />}
            </TopToolbar>
        )
    }
    return (<p></p>)
};

export const RolesShow = props => {
    const [width, setWindowWidth] = useState(0)

    useEffect(() => {

        updateDimensions();

        window.addEventListener("resize", updateDimensions);
        return () =>
            window.removeEventListener("resize", updateDimensions);
    }, [])
    const updateDimensions = () => {
        const width = window.innerWidth
        setWindowWidth(width)
    }

    const responsive = {
        web: width > 1023
    }

    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }

    return (
        <div>
            <div style={(responsive.web) ? styles.div1 : styles.div1Mobile}>
                <Show title={<RoleTitle />} actions={<RoleShowActions edit={true} />} {...props}>
                    <SimpleShowLayout >
                        <TextField source="role" label='Nombre del rol' />
                        <TextField source="description" label='Descripción' />
                    </SimpleShowLayout>
                </Show>
            </div>
            <div style={(responsive.web) ? styles.div2 : styles.div2Mobile}>
                {(permissions.includes("roles.list")) ?
                    <Show title={<RoleTitle optionTitle={true} />} {...props} resource={"roles"} actions={<RoleShowActions right={true} />} >
                        <SimpleShowLayout>
                            <PermitsList permissions_logged_user={permissions} real_role={true}/>
                        </SimpleShowLayout>
                    </Show>
                    : null}
            </div>
        </div>
    )
};

const RoleFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Buscar" source="q" alwaysOn />
    </Filter>
);

export const RolesCreate = props => (
    <Create {...props}>
        <SimpleForm submitOnEnter={false}>
            <TextInput source="role" label='Nombre del rol' />
            <TextInput source="description" label='Descripción' />
        </SimpleForm>
    </Create>
);

export const RolesEdit = props => (
    <Edit {...props}>
        <SimpleForm submitOnEnter={false} toolbar={<RoleEditToolbar />}>
            <TextInput source="role" label='Nombre' />
            <TextInput source="description" label='Descripción' />
        </SimpleForm>
    </Edit>
);

const RoleEditToolbar = props => (
    <Toolbar {...props} >
        <SaveButton />
    </Toolbar>
);